import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Badge } from 'antd';
import { 
    HomeOutlined, 
    ShopOutlined, 
    ShoppingCartOutlined, 
    HeartOutlined,
    UserOutlined 
} from '@ant-design/icons';
import { useCart } from '../../contexts/CartContext';
import { useWishlist } from '../../contexts/WishlistContext';
import { useAuth } from '../../contexts/AuthContext';

const MobileNavigation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { getCartItemCount } = useCart();
    const { getWishlistCount } = useWishlist();
    const { isAuthenticated } = useAuth();

    const cartCount = getCartItemCount();
    const wishlistCount = getWishlistCount();

    const navItems = [
        {
            key: 'home',
            path: '/',
            icon: <HomeOutlined />,
            label: 'Home',
            show: true
        },
        {
            key: 'vendors',
            path: '/vendors',
            icon: <ShopOutlined />,
            label: 'Vendors',
            show: true
        },
        {
            key: 'cart',
            path: '/cart',
            icon: <ShoppingCartOutlined />,
            label: 'Cart',
            badge: cartCount,
            show: true
        },
        {
            key: 'wishlist',
            path: '/wishlist',
            icon: <HeartOutlined />,
            label: 'Wishlist',
            badge: wishlistCount,
            show: true
        },
        {
            key: 'profile',
            path: isAuthenticated ? '/dashboard' : '/login',
            icon: <UserOutlined />,
            label: 'Profile',
            show: true
        }
    ];

    const handleNavigation = (path) => {
        navigate(path);
    };

    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-gray-200/80 shadow-2xl dark:bg-gray-800/95 dark:border-gray-700 md:hidden safe-area-bottom">
            <div className="flex items-center justify-around py-2 px-2">
                {navItems.map((item) => {
                    if (!item.show) return null;
                    
                    const active = isActive(item.path);
                    
                    return (
                        <button
                            key={item.key}
                            onClick={() => handleNavigation(item.path)}
                            className={`flex flex-col items-center justify-center py-2 px-4 rounded-xl transition-all duration-300 min-w-[60px] ${
                                active 
                                    ? 'text-[#C97D60] dark:text-[#E8A88A] bg-[#F5F3F0] dark:bg-[#C97D60]/20 scale-105' 
                                    : 'text-gray-600 dark:text-gray-400 hover:text-[#C97D60] dark:hover:text-[#E8A88A] hover:bg-gray-50 dark:hover:bg-gray-700/50'
                            }`}
                        >
                            <div className="relative">
                                {item.badge && item.badge > 0 ? (
                                    <Badge count={item.badge} size="small" offset={[-4, 4]} color="#C97D60">
                                        <span className={`text-2xl transition-transform duration-300 ${active ? 'scale-110' : ''}`}>
                                            {item.icon}
                                        </span>
                                    </Badge>
                                ) : (
                                    <span className={`text-2xl transition-transform duration-300 ${active ? 'scale-110' : ''}`}>
                                        {item.icon}
                                    </span>
                                )}
                            </div>
                            <span className={`text-[10px] mt-1 font-semibold transition-all duration-300 ${
                                active 
                                    ? 'text-[#C97D60] dark:text-[#E8A88A]' 
                                    : 'text-gray-600 dark:text-gray-400'
                            }`}>
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileNavigation;
